<template>
  <div class="zcbody">
    <div class="protocol-accept1">
      <span>
        <font style="color:red">*</font>&nbsp;<b>公司案例</b>
      </span>
      <el-button size="mini" type="success" class="pull-right" @click="addtable">新增</el-button>
    </div>
    <el-table :data="tableSDA" border style="width: 100%" max-height="420" tooltip-effect
      :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="ckhname" label="合作客户" width="200"></el-table-column>
      <el-table-column prop="chtstart" label="合作时间" width="100"></el-table-column>
      <el-table-column prop="chtinfo" label="内容描述" width="200"></el-table-column>
      <el-table-column prop="chtpath" label="附件地址"></el-table-column>
      <el-table-column prop="chtname" label="附件名称"></el-table-column>

      <el-table-column prop="name" label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="regit(scope.row, scope.$index)"
            style="marign-right: 5px">修改</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row, scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增公司案例" :visible.sync="dialogFormVisible" customClass="way sadform1" :append-to-body="true">
      <el-form ref="sdaruleForm" :rules="sdarules" :model="sdaform" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合作客户:" prop="ckhname">
              <el-input v-model="sdaform.ckhname" placeholder="请输入合作客户"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合作时间:" prop="chtstart">
              <el-date-picker type="date" v-model="sdaform.chtstart" value-format="yyyy-MM-dd"
                placeholder="合作时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容描述:" prop="chtinfo">
              <el-input type="textarea" v-model="sdaform.chtinfo" placeholder="请输入内容描述" maxlength="200" rows="4"
                style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- <el-form-item label="附件地址:" prop="cusertel">
              <el-input v-model="sdaform.cusertel" placeholder="请输入手机"></el-input>
            </el-form-item> -->
            <el-form-item prop="chtpath" label="合同文件:">
              <el-upload style="display:inline-block;margin:0" action="#" ref="uploadFail" :show-file-list="false"
                :before-upload="brforeUploadreImportFail" :auto-upload="false" :on-change="handleChangeFail"
                :file-list="fileListFail" :accept="typeaccept">
                <el-button type="success" plain size="medium">上传合同文件({{typeaccept}})</el-button>
              </el-upload>
              <br>{{sdaform.chtname}}
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad('sdaruleForm')">取 消</el-button>
        <el-button type="success" @click="confirm('sdaruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { GetFileType } from "../../../api/home";
  export default {
    props: {
      anlitable: { Type: Object },
      urlid: { Type: String },
    },
    data() {
      return {
        state: "-1",
        dialogFormVisible: false,
        tableSDA: [],
        sdaform: {
          ckhname: "",
          chtstart: "",
          chtinfo: "",
          chtname: "",
          chtpath: "",
        },
        fileListFail: [],
        typeaccept: "",
        sdarules: {
          ckhname: [{ required: true, message: "合作客户", trigger: "blur" }],
          chtstart: [{ required: true, message: "合作时间", trigger: "blur" }],
          chtinfo: [{ required: true, message: "合作内容描述", trigger: "blur" }],
          chtpath: [{ required: true, message: "请上传文件", trigger: "blur" }],
        },
      };
    },
    created() {
      console.log(this.anlitable);
      this.tableSDA = this.anlitable;
      console.log(this.urlid);
      this.FileType();
    },
    methods: {
      // 获取文件类型
      FileType() {
        GetFileType({ type: "08" }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.typeaccept = res.data.Data[0].cfileformat;
          }
        });
      },
      //上传文件
      handleChangeFail(file, fileList) {
        this.$refs.uploadFail.submit();
      },
      // 上传文件
      brforeUploadreImportFail(file) {
        console.log(this.urlid);

        let varparams = new FormData();
        varparams.append("file", file);
        varparams.append("file", URL.createObjectURL(file));
        varparams.append("cvoucherno", "Base_customer_11");
        varparams.append("ctype", "08");
        varparams.append("cvoucherid", this.urlid);
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/BaseUploadFile",
          headers: { "Content-Type": "multipart/form-data" },
          data: varparams,
          timeout: 30000000,
        }).then((res) => {
          console.log(res, "上传结果");
          if (res.data.Success) {
            this.$message({
              howClose: true,
              message: "上传成功",
              type: "success",
            });

            this.sdaform.chtpath = res.data.Data.Path;
            this.sdaform.chtname = res.data.Data.Cname;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      addtable() {
        this.state = "-1";
        this.dialogFormVisible = true;
        this.sdaform = {
          ckhname: "",
          chtstart: "",
          chtinfo: "",
          chtname: "",
          chtpath: "",
        };
      },
      closesad(sdaruleForm) {
        this.$refs[sdaruleForm].resetFields();
        this.dialogFormVisible = false;
      },
      confirm(sdaruleForm) {
        this.$refs[sdaruleForm].validate((valid) => {
          if (valid) {
            if (this.sdaform.chtpath == "") {
              this.$message.error("请上传文件");
            } else {
              console.log(this.state);
              if (this.state == "-1") {
                this.tableSDA.push(this.sdaform);
              } else {
                this.tableSDA.splice(this.state, 1);
                console.log(this.tableSDA);
                setTimeout(() => {
                  this.tableSDA.push(this.sdaform);
                  this.$emit("anlilist", this.tableSDA);
                }, 30);
              }
              this.dialogFormVisible = false;

              console.log(this.tableSDA);
            }
          } else {
            return false;
          }
        });
      },
      regit(row, i) {
        this.state = i;
        this.sdaform = row;
        this.dialogFormVisible = true;
      },
      del(row, i) {
        this.tableSDA.splice(i, 1);
      },
    },
  };
</script>
<style scoped>
  @import url(../../../assets/css/reg.css);
</style>